import { useTranslation } from 'react-i18next';
import styles from './ServiceInformationView.module.css';
import commonStyles from '../common.module.css';
import Customer from '../../../models/Customer';
import QuestionnaireTable from './Questionnaire/QuestionnaireTable';

type ServiceInformationProps = {
  customer: Customer
}

function ServiceInformationView(props: ServiceInformationProps) {
  const { t } = useTranslation();

  const isChecked = (item: string, checklist: string[]) => checklist.includes(item)
    ? <div className={styles.checked} />
    : <div className={styles.unchecked} />;

  return (
    <>
      <div className={commonStyles.checklist}>
        <div className={styles.checklistTitle}>
          {t('customer.serviceInfo.label.firstServiceInfoQuestion')}
        </div>
        <div className={styles.firstChecklist}>
          <div className={styles.checklistItem}>
            {isChecked('FINANCIAL_ADVISORY', props.customer.servicesProvided)}
            <div className={styles.itemName}>
              {t('customer.serviceInfo.checklist.service.financialAdvisory')}
            </div>
          </div>
          <div className={styles.checklistItem}>
            {isChecked('WEALTH_MANAGEMENT', props.customer.servicesProvided)}
            <div className={styles.itemName}>
              {t('customer.serviceInfo.checklist.service.wealthManagement')}
            </div>
          </div>
        </div>
      </div>
      <div className={commonStyles.checklist}>
        <div className={styles.checklistTitle}>
          {t('customer.serviceInfo.label.secondServiceInfoQuestion')}
        </div>
        <QuestionnaireTable
          customerId={props.customer.id!}
          customerQuestionnairesRequired={props.customer.questionnaireTypesRequired}
        />
      </div>
    </>
  );
}

export default ServiceInformationView;
